import React from 'react';
import { Link } from './LabelLink.styles';

export const LabelLink = ({
	onClick,
	title,
	active,
}: {
	active: boolean;
	onClick: () => void;
	title: string;
}) => {
	return (
		<Link active={active} onClick={() => active && onClick()}>
			{title}
		</Link>
	);
};
